import React from 'react';

const IconCashbackRepeatCustomers = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 18.665C8.36555 19.7325 7.31333 21.3892 7.31333 23.25V25H3.10444C1.93998 25 1 24.2183 1 23.25V22.0833C1 19.8258 3.19564 18 5.91037 18H7.31333C8.30943 18 9.22837 18.245 10 18.665Z'
      fill='#17C981'
    />
    <path
      d='M22.333 17.7493C23.9899 17.7493 25.333 16.4061 25.333 14.7493C25.333 13.0924 23.9899 11.7493 22.333 11.7493C20.6762 11.7493 19.333 13.0924 19.333 14.7493C19.333 16.4061 20.6762 17.7493 22.333 17.7493Z'
      fill='#17C981'
    />
    <path
      d='M6.33301 17.7493C7.98986 17.7493 9.33301 16.4061 9.33301 14.7493C9.33301 13.0924 7.98986 11.7493 6.33301 11.7493C4.67615 11.7493 3.33301 13.0924 3.33301 14.7493C3.33301 16.4061 4.67615 17.7493 6.33301 17.7493Z'
      fill='#17C981'
    />
    <path
      d='M27.333 22.4159V23.7493C27.333 24.8559 26.4975 25.7493 25.4624 25.7493H21.7212V23.7493C21.7212 21.6226 20.7859 19.7293 19.333 18.5093C20.0189 18.0293 20.8357 17.7493 21.7212 17.7493H22.9682C25.3813 17.7493 27.333 19.8359 27.333 22.4159Z'
      fill='#17C981'
    />
    <path
      d='M14.833 18.7493C16.766 18.7493 18.333 17.1823 18.333 15.2493C18.333 13.3163 16.766 11.7493 14.833 11.7493C12.9 11.7493 11.333 13.3163 11.333 15.2493C11.333 17.1823 12.9 18.7493 14.833 18.7493Z'
      fill='#17C981'
    />
    <path
      d='M14.9997 18.7493H13.6663C10.7257 18.7493 8.33301 21.0565 8.33301 23.8921V25.8207C8.33301 26.884 9.23034 27.7493 10.333 27.7493H18.333C19.4357 27.7493 20.333 26.884 20.333 25.8207V23.8921C20.333 21.0565 17.9403 18.7493 14.9997 18.7493Z'
      fill='#17C981'
    />
    <path
      d='M23.833 9.14052L22.2975 9.70912C21.8616 9.87015 21.4066 9.52621 21.4193 9.04443L21.4639 7.34791L20.4699 6.00263C20.188 5.62092 20.3617 5.06358 20.8053 4.92707L22.3688 4.44727L23.2902 3.04699C23.5517 2.65003 24.1143 2.65003 24.3758 3.04699L25.2972 4.44727L26.8607 4.92707C27.3043 5.06292 27.478 5.62092 27.1961 6.00263L26.2021 7.34791L26.2467 9.04443C26.2594 9.52555 25.8038 9.87015 25.3685 9.70912L23.833 9.14052Z'
      fill='#FCA600'
    />
    <path
      d='M4.83301 9.14052L3.2975 9.70912C2.86161 9.87015 2.40662 9.52621 2.41935 9.04443L2.46389 7.34791L1.46992 6.00263C1.18802 5.62092 1.36174 5.06358 1.80527 4.92707L3.36878 4.44727L4.2902 3.04699C4.55174 2.65003 5.11427 2.65003 5.37581 3.04699L6.29724 4.44727L7.86074 4.92707C8.30428 5.06292 8.478 5.62092 8.1961 6.00263L7.20212 7.34791L7.24667 9.04443C7.2594 9.52555 6.80377 9.87015 6.36851 9.70912L4.83301 9.14052Z'
      fill='#FCA600'
    />
    <path
      d='M14.3327 8.0536L12.5779 8.70322C12.0798 8.88782 11.5597 8.49371 11.5744 7.94374L11.6253 6.00511L10.4893 4.46763C10.1673 4.03136 10.366 3.39452 10.8727 3.23866L12.6594 2.68997L13.7126 1.08988C14.0113 0.635729 14.6547 0.635729 14.9534 1.08988L16.0066 2.68997L17.7933 3.23866C18.3 3.39452 18.4987 4.03136 18.1767 4.46763L17.0407 6.00511L17.0916 7.94374C17.1064 8.49371 16.5856 8.88782 16.0882 8.70322L14.3327 8.0536Z'
      fill='#FCA600'
    />
  </svg>
);

export default IconCashbackRepeatCustomers;
